import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import styles from './App.module.scss';
import Router from './Router';
import { Header } from '../Shared/Header/Header';
import { Footer } from '../Shared/Footer/Footer';
import { AuthProvider } from '../../context/AuthContext';
import { UserContextProvider } from '../../context/UserContext';
import { BrowserRouter } from 'react-router-dom';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

function App(): React.JSX.Element {
    return (
        <div className={styles.app}>
            <QueryClientProvider client={queryClient}>
                <UserContextProvider>
                    <AuthProvider>
                        <BrowserRouter basename="/admin">
                            <Header />
                            <div className={styles.content}>
                                <Router />
                            </div>
                            <Footer />
                        </BrowserRouter>
                    </AuthProvider>
                </UserContextProvider>
            </QueryClientProvider>
        </div>
    );
}

export default App;
